import React from "react";
import { number, bool, string } from "prop-types";

import Icon from "../icon";

const Google = ({ width = 37.182, height = 38.275, isShareRequired, text }) => (
  <Icon type="google" isShareRequired={isShareRequired} text={text}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 37.182 38.275">
      <g transform="translate(-650.51 -544.531)">
        <path
          d="M4.042 0h29.1a4.1 4.1 0 0 1 4.042 4.16v29.955a4.1 4.1 0 0 1-4.042 4.16h-29.1A4.1 4.1 0 0 1 0 34.115V4.16A4.1 4.1 0 0 1 4.042 0z"
          transform="translate(650.51 544.531)"
          fill="#fff"
        />
        <g transform="translate(659.403 553.683)">
          <path
            d="M18.373 9.419a11.879 11.879 0 0 0-.173-2.055H9v3.888h5.254a4.633 4.633 0 0 1-1.948 3.033v2.522h3.155a9.949 9.949 0 0 0 2.911-7.387z"
            transform="translate(.763 .859)"
            fill="#4285f4"
            fillRule="evenodd"
          />
          <path
            d="M9.682 18.851a9.168 9.168 0 0 0 6.462-2.435l-3.155-2.522a5.746 5.746 0 0 1-3.306.959 5.841 5.841 0 0 1-5.464-4.143H.957v2.6a9.735 9.735 0 0 0 8.725 5.537z"
            transform="translate(.081 1.25)"
            fill="#34a853"
          />
          <path
            d="M4.3 11.381a6.107 6.107 0 0 1 0-3.819v-2.6H1.038a10.328 10.328 0 0 0 0 9.027l3.262-2.6z"
            transform="translate(0 .579)"
            fill="#febf0f"
            fillRule="evenodd"
          />
          <path
            d="M9.682 4a5.193 5.193 0 0 1 3.732 1.5l2.8-2.883A9.239 9.239 0 0 0 9.682 0 9.735 9.735 0 0 0 .957 5.537l3.262 2.6A5.841 5.841 0 0 1 9.682 4z"
            transform="translate(.081)"
            fill="#ea4335"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  </Icon>
);

Google.propTypes = {
  width: number,
  height: number,
  isShareRequired: bool,
  text: string,
};

export default Google;
